import React, { forwardRef, } from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Field } from '../fields/Field';
import { Input, StyledFrontIcon, StyledTrailingIcon, } from '../fields/components/CommonInput';
import { useUniqueId } from '../utils/id';
export const NumberInput = forwardRef(function NumberInput({ id: idProp, type = 'number', placeholder, name, value, onChange, onInputChange, onBlur, min = -999999, max = 999999, step = 0, disabled = false, error = false, frontIcon, trailingIcon, fallbackStyle, ...fieldProps }, ref) {
    const id = useUniqueId(idProp);
    // Check whether the min/max value exists is within the specified range
    const isInRange = (value) => {
        if (min && value < min) {
            return false;
        }
        if (max && value > max) {
            return false;
        }
        return true;
    };
    // Round the number to two decimal places
    const roundNumber = (event) => {
        return Math.round(event * 100) / 100;
    };
    const applyMinMax = (value) => {
        if (min && value < min)
            return min;
        if (max && value > max)
            return max;
        return value;
    };
    const handleChange = (event) => {
        if (onChange === undefined)
            return;
        const EMPTY_INPUT = '';
        if (event === EMPTY_INPUT) {
            onChange(event);
        }
        else {
            const amount = Number(event);
            const normalisedValue = applyMinMax(amount);
            onChange(normalisedValue);
        }
    };
    // Increment or decrement the value when clicking the Spinner controls
    const incrementValue = (event) => {
        if (onChange === undefined)
            return;
        event.preventDefault();
        const currentValue = Number(value) + step;
        if (isInRange(currentValue)) {
            onChange(roundNumber(currentValue));
        }
    };
    const decrementValue = (event) => {
        if (onChange === undefined)
            return;
        event.preventDefault();
        const currentValue = Number(value) - step;
        if (isInRange(currentValue)) {
            onChange(roundNumber(currentValue));
        }
    };
    return (React.createElement(Field, { ...fieldProps, htmlFor: id, error: error },
        React.createElement(Box, { flex: true, alignItems: "center", justifyContent: "flex-start" },
            frontIcon && (React.createElement(StyledFrontIcon, { "$disabled": disabled, render: frontIcon, color: "sesame" })),
            React.createElement(Input, { ref: ref, "$error": error, disabled: disabled, type: type, id: id, name: name, placeholder: placeholder, value: value, "$frontIcon": frontIcon, step: step, "$fallbackStyle": fallbackStyle, onWheel: (e) => e.currentTarget.blur(), onChange: (e) => {
                    onChange && handleChange(e.currentTarget.value);
                    onInputChange && onInputChange(e);
                }, onBlur: onBlur }),
            onChange && step > 0 && (React.createElement(Spinner, null,
                React.createElement(SpinnerButton, { "aria-label": "step-up", onClick: incrementValue, disabled: disabled },
                    React.createElement(Icon, { render: "caret", rotate: 180, color: "sesame", size: 24 })),
                React.createElement(SpinnerButton, { "aria-label": "step-down", onClick: decrementValue, disabled: disabled },
                    React.createElement(Icon, { render: "caret", color: "sesame", size: 24 })))),
            trailingIcon && !step && (React.createElement(StyledTrailingIcon, { "$disabled": disabled, render: trailingIcon, color: "sesame" })))));
});
const Spinner = styled.div `
  position: relative;
  display: flex;
  right: 58px;
  margin-right: -58px;
`;
const SpinnerButton = styled.button `
  width: 24px;
  height: 24px;
  background-color: transparent;
  border: 0;
  padding: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
//# sourceMappingURL=NumberInput.js.map